import React, { useEffect, useState } from "react";
import { useCart } from "../../contexts/CartContext";
import { Button, TextField } from "@mui/material";
import { toast } from "react-toastify";
import "./style/CartPage.css";

const CartPage: React.FC = () => {
  const { cartItems, removeFromCart, addToCart, setCartItems } = useCart();
  const [quantityInputs, setQuantityInputs] = useState<{ [id: number]: number }>({});
  const [imagePath, setImagePath] = useState("http://localhost:3001");

  useEffect(() => {
    setImagePath(process.env.REACT_APP_API_URL || "http://localhost:3001");
  }, []);

  useEffect(() => {
    const savedCartItems = localStorage.getItem("cartItems");
    if (JSON.parse(savedCartItems?.toString() || "[]").length > 0) {
      setCartItems(JSON.parse(savedCartItems || "[]"));
    }
  }, [setCartItems]);

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  const getImageUrl = (image: string | null) => {
    return image ? `${imagePath}${image}` : `${imagePath}media/productImage/default.jpg`;
  };

  const subtotal = cartItems.reduce((total, item) => {
    const price = Number(item.regular_price);
    const quantity = Number(item.quantity);
    return total + price * quantity;
  }, 0);

  const totalQuantity = cartItems.reduce((total, item) => {
    const quantity = Number(item.quantity);
    return total + quantity;
  }, 0);

  const handleQuantityChange = (item: any, newQuantity: string) => {
    const parsedQuantity = parseInt(newQuantity, 10);
    if (!isNaN(parsedQuantity)) {
      if (parsedQuantity <= 0) {
        toast.error("La cantidad debe ser mayor a 0.", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          style: { backgroundColor: "darkred", color: "white" },
        });
        return;
      }
      if (parsedQuantity > item.stock_quantity) {
        toast.error("La cantidad supera el stock disponible.", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          style: { backgroundColor: "darkred", color: "white" },
        });
        return;
      }

      setQuantityInputs((prev) => ({ ...prev, [item.id]: parsedQuantity }));
      addToCart(item, parsedQuantity - item.quantity);
    }
  };

  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.src = `${imagePath}media/productImage/default.jpg`;
  };

  const handleRemoveFromCart = (item: any) => {
    removeFromCart(item.id);
    toast.error(`Eliminaste el producto ${item.name} del carrito`, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: true,
      style: { backgroundColor: "darkred", color: "white" },
    });
  };

  return (
    <div className="cart-page">
      <h1>Carrito de Compras</h1>
      <div className="cart-summary">
        <p>
          <strong>Subtotal:</strong> ${subtotal.toFixed(2)}
        </p>
        <p>
          <strong>Cantidad de productos:</strong> {totalQuantity}
        </p>
      </div>
      {cartItems.length === 0 ? (
        <p>No hay productos en el carrito.</p>
      ) : (
        <div className="cart-grid">
          {cartItems.map((item) => (
            <div className="cart-item" key={item.id}>
              <div className="cart-image-container">
                <img
                  src={getImageUrl(item.image)}
                  alt={item.name}
                  className="cart-image"
                  onError={handleImageError}
                />
              </div>
              <div className="cart-details">
                <p>
                  <strong>SKU:</strong> {item.sku}
                </p>
                <p>
                  <strong>Descripción:</strong> {item.name}
                </p>
                <p>
                  <strong>Precio:</strong> ${item.regular_price}
                </p>
                <div className="cart-quantity-row">
                  <TextField
                    type="number"
                    label="Cantidad"
                    variant="outlined"
                    size="small"
                    inputProps={{
                      min: 1,
                      max: item.stock_quantity,
                      style: { textAlign: "center" },
                    }}
                    value={quantityInputs[item.id] || item.quantity}
                    onChange={(e) => handleQuantityChange(item, e.target.value)}
                    className="quantity-input"
                  />
                  <Button
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={() => handleRemoveFromCart(item)}
                  >
                    Eliminar
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CartPage;